import { render, staticRenderFns } from "./ActiveTripsV2.vue?vue&type=template&id=9d3b00a0&scoped=true&"
import script from "./ActiveTripsV2.vue?vue&type=script&lang=js&"
export * from "./ActiveTripsV2.vue?vue&type=script&lang=js&"
import style0 from "./ActiveTripsV2.vue?vue&type=style&index=0&id=9d3b00a0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d3b00a0",
  null
  
)

export default component.exports